export default {
  title: {
    base: 'What our clinics',
    keyword: 'have to say about us:',
  },
  cards: CLINIC_TESTIMONIALS,
};
